var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.326 9.412l-3.298-1.478-.009-.004a1.12 1.12 0 00-1.114.137L7.2 9.52c-1.08-.524-2.194-1.63-2.718-2.696l1.454-1.73a1.12 1.12 0 00.132-1.108v-.008L4.589.675A1.12 1.12 0 003.424.008 3.938 3.938 0 000 3.92C0 9.478 4.522 14 10.08 14a3.938 3.938 0 003.912-3.424 1.12 1.12 0 00-.666-1.164zM10.08 12.88a8.97 8.97 0 01-8.96-8.96 2.814 2.814 0 012.44-2.8v.008l1.47 3.29L3.585 6.15a1.12 1.12 0 00-.11 1.153c.634 1.297 1.941 2.594 3.252 3.228a1.12 1.12 0 001.155-.12L9.582 8.96l3.29 1.473h.008a2.815 2.815 0 01-2.8 2.447z"
  })));
}
export default SvgPhone;